import { client } from '@/client';

// 脚本列表
export function getScriptList(params) {
  return client.post('/api/ops_script_stencil/page-query', params);
}

// 脚本导出
export function scriptExport(params) {
  return client.post('/api/ops_script_stencil/script/stencil/export', params);
}

// 组件导出
export function componentExport(params) {
  return client.post('/api/ops_component_stencil/component/stencil/export', params);
}

// 流程导出
export function flowExport(params) {
  return client.post('/api/flow_stencil_base_info/flow/stencil/export', params);
}

// 删除脚本
export function deleteScript(scriptStencilId) {
  return client.delete(`/api/ops_script_stencil/delete/${scriptStencilId}`);
}

// 删除组件
export function deleteComponent(componentStencilId) {
  return client.delete(`/api/ops_component_stencil/delete/${componentStencilId}`);
}
// 删除流程
export function deleteFlow(opsFlowStencilBaseInfoId) {
  return client.delete(`/api/flow_stencil_base_info/delete/${opsFlowStencilBaseInfoId}`);
}

// 上传JSON脚本
export function uploadScriptFile(params) {
  return client.form('/api/ops_script_stencil/script/stencil/import', params);
}

// 上传组件JSON
export function uploadComponentFile(params) {
  return client.form('/api/ops_component_stencil/component/stencil/import', params);
}

// 上传流程JSON
export function uploadFlowFile(params) {
  return client.form('/api/flow_stencil_base_info/flow/stencil/import', params);
}

// 组件列表
export function getComponentList(params) {
  return client.post('/api/ops_component_stencil/page-query', params);
}

// 流程列表
export function getFlowList(params) {
  return client.get('/api/flow_stencil_base_info/listAll', params);
}

export function getFlowGroupList(params) {
  return client.post('/api/ops_hosts/selectHostsGroup', params);
}

export function saveFlowGroup(params) {
  return client.post('/api/ops_hosts/addHostsGroup', params);
}

export function updateFlowGroup(params) {
  return client.post('/api/ops_hosts/updateHostsGroup', params);
}

export function moveFlowGroup(params) {
  return client.post('/api/ops_hosts/moveHostsGroup', params);
}

export function deleteFlowGroup(id) {
  return client.get('/api/ops_hosts/deleteHostsGroup', { id });
}

// 变量列表
export function getVariableList(componentStencilId) {
  return client.get(`/api/ops_component_stencil/list-variable/${componentStencilId}`);
}

// 创建脚本
export function createScript(params) {
  return client.post('/api/ops_script_stencil/create', params);
}

// 创建组件
export function createComponent(params) {
  return client.post('/api/ops_component_stencil/create', params);
}

// 创建流程
export function createFlow(params) {
  return client.post('/api/flow_stencil_base_info/create', params);
}

// 修改脚本
export function updateScript(params) {
  return client.post('/api/ops_script_stencil/update', params);
}

// 更新组件
export function updateComponent(params) {
  return client.post('/api/ops_component_stencil/update', params);
}

// 更新流程
export function updateFlow(params) {
  return client.post('/api/flow_stencil_base_info/update', params);
}

// 更新流程步骤
export function updateFlowStep(params) {
  return client.post('/api/flow_stencil_step_info/update', params);
}

// 比对
export function diffComponent(params) {
  return client.post('/api/ops_component_stencil/linediff', params);
}

// 比对
export function diffFlow(params) {
  return client.post('/api/flow_stencil_step_info/diff', params);
}

// 获取脚本详情
export function getScriptById(id) {
  return client.get(`/api/ops_script_stencil/detail/${id}`);
}

// 获取组件详情
export function getComponentById(id) {
  return client.get(`/api/ops_component_stencil/detail/${id}`);
}

// 获取流程列表数据
export function getFlowDataById(id) {
  return client.get(`/api/flow_stencil_step_info/listByBaseId/${id}`);
}

export function getComponentSearch(params) {
  return client.get('/api/ops_component_stencil/search', params);
}
